import { postRequest3, getRequest } from '@/libs/request.js'

// 文件上传
export const upLoadFileAPI = params => {
  return postRequest3('/file/file/uploadFile', params)
}

// 文件预览接口
export const viewFileAPI = params => {
  return getRequest('/file/wpsFile/onlinePreviewUrl', params,'fileSever')
}

// 文件下载接口
export const downloadFileAPI = params => {
  return getRequest('/file/file/getPathByID', params,'fileSever')
}

// 文件下载接口
export const downloadFile = params => {
  return getRequest('/file/file/getPathByID', params,'fileSever')
}
